module.exports = __webpack_public_path__ + "assets/img/receive-bg.407f82c5.png";